import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function BranchSelect({ value, onChange, allowAll = false, className = '', testId = 'branch-select' }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const defaulted = useRef(false);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    api.get('/branches').then(r => {
      let list = (r.data?.branches || []).filter(b => b.is_active);
      const bids = user?.branch_ids || [];
      const isAdmin = ['admin', 'owner', 'super_admin'].includes(user?.role);
      if (!isAdmin && bids.length) list = list.filter(b => bids.includes(b.branch_id));
      setBranches(list);
      if (!allowAll && !defaulted.current && !valueRef.current && list.length) {
        defaulted.current = true;
        const def = (!isAdmin && bids.length) ? list[0] : (list.find(b => b.is_head_office) || list[0]);
        onChangeRef.current(def.branch_id);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.role]);

  return (
    <select value={value || ''} onChange={e => onChange(e.target.value)} className={`form-input ${className}`} data-testid={testId}>
      {allowAll && <option value="">All Branches</option>}
      {!allowAll && !value && <option value="">Select branch</option>}
      {branches.map(b => <option key={b.branch_id} value={b.branch_id}>{b.name} ({b.code})</option>)}
    </select>
  );
}
